import { DOMOutputSpec, MarkSpec } from "prosemirror-model";

const strikeThroughDOM: DOMOutputSpec = ["s", 0];

export const strikeThrough: MarkSpec = {
	parseDOM: [
		{tag: "s"},
		{tag: "strike"},
		{style: "text-decoration=line-through"},
		{style: "text-decoration-line=line-through"}
	],
	toDOM: () => strikeThroughDOM
};